import { Fetch } from "../apiConfig/Fetch";
import { ApiConfig } from "../apiConfig/apiConfig";

const PeopleService = {
    insertOrUpdate: async (data) => {
        const { baseUrl, insertOrUpdatePeople } = ApiConfig;
        const url = baseUrl + insertOrUpdatePeople;

        return await Fetch(
            url,
            "POST",
            {},
            {
                userId: data.userId,
                peopleId: data.peopleId,
                fullName: data.name,
                photoURL: data.photo,
                designationId: data.designationId,
                description: data.description,
                link: data.link,
                typeId: data.typeId,
            },
            "services_peopleService_insertOrUpdate",
            true
        );
    },

    getPeopleList: async () => {
        const { baseUrl, getPeopleList } = ApiConfig;
        const url = baseUrl + getPeopleList;

        return await Fetch(
            url,
            "GET",
            {},
            null,
            "services_people_getPeopleList"
        );
    },

    enableDisableUser: async (data) => {
        const { baseUrl, enableDisableUser } = ApiConfig;
        const url = baseUrl + enableDisableUser;

        return await Fetch(
            url,
            "POST",
            {},
            {
                userId: data.userId,
                peopleId: data.peopleId,
                status: data.status,
            },
            "services_enableDisableUser",
            true
        );
    },
};

export default PeopleService;
